import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { DialogBase, DialogOptions } from '@marmon/frontend/common';
import { ColorCodeCellComponent } from '../../components';
import { AnalysisCostType } from '@marmon/shared/types/analysis';

@Component({
	standalone: true,
	imports: [TranslocoPipe, ColorCodeCellComponent],
	selector: 'mar-top-count-entity-calculation-dialog',
	templateUrl: 'top-count-entity-calculation-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopCountEntityCalculationDialogComponent extends DialogBase<
	void,
	{ costType: AnalysisCostType }
> {
	static override readonly DialogOptions = {
		size: 'm',
	} as DialogOptions;

	readonly costType = computed(() =>
		this.context.data.costType === 'direct' ? 'cm' : 'mm',
	);

	readonly prefix = 'customer-product.top-count.dialog.calculation-dialog';
}
